<template>
    <stu-page class="m-myTaskDetailOff">
        <div class="offline-container">
            <h2 class="task-title">{{data.name}}</h2>

            <div class="task-info">
                <div class="basic-info">
                    <h3>{{$t('train.basicInfo')}}</h3>
                    <p>{{$t('train.site')}}：{{data.place}}</p>
                    <p>{{$t('c.startTime')}}：{{data.startTime}}</p>
                    <p>{{$t('c.endTime')}}：{{data.endTime || '-'}}</p>
                    <p>{{$t('train.classHour')}}：{{data.period}}</p>
                    <p>{{$t('train.content')}}：{{data.content}}</p>
                </div>
                <div class="user-info" v-if="user.status">
                    <h3>{{$t('train.userStatus')}}</h3>
                    <p>{{$t('c.status')}}：{{user.statusName}}</p>
                    <p v-if="user.reason">{{$t('train.absentReason')}}：{{user.reason}}</p>
                    <p v-if="user.remark">{{$t('system.remark')}}：{{user.remark}}</p>
                </div>
            </div>

            <baidu-map class="bm-map"
                       :center="center"
                       :zoom="17"
                       :scroll-wheel-zoom="true"
                       @ready="onMapReady"
            >
                <bm-view class="bm-view"></bm-view>
            </baidu-map>
        </div>
    </stu-page>
</template>

<script>
    import StuPage from '@/components/Stupage.vue';
    import api from '@/api';

    export default {
        props: ['taskId'],
        data() {
            return {
                data: {},
                user: {},
                center: {
                    lng: 116.404, lat: 39.915
                },
                range: 0,
            }
        },
        created() {
            this.query();
        },
        computed: {},
        methods: {
            query(){
                api.getOfflineDetail(this.taskId).then(res => {
                    this.data = res.package;
                    this.user = res.package.currentUserStatus;
                    console.log(this.data)

                    if (this.map) this.setMap(this.data);
                })
            },

            onMapReady({BMap, map}) {
                this.BMap = BMap;
                this.map = map;

                map.addControl(new BMap.NavigationControl({
                    type: BMAP_NAVIGATION_CONTROL_SMALL,
                    anchor: BMAP_ANCHOR_TOP_RIGHT
                }));
                map.addControl(new BMap.ScaleControl());

                //加载地图信息
                if (this.data.coordinate) {
                    this.setMap(this.data);
                }
            },
            // 定位到已有位置
            setMap(data) {
                let lat = data.coordinate && data.coordinate.split(',')[0];
                let lng = data.coordinate && data.coordinate.split(',')[1];
                let point = new this.BMap.Point(lng, lat);

                // 创建标注
                let marker = new this.BMap.Marker(point);
                this.map.addOverlay(marker);
                let label = new this.BMap.Label(data.place,{offset:new this.BMap.Size(20,-10)});
                marker.setLabel(label);

                this.center.lat = lat;
                this.center.lng = lng;

                // 加载用户打卡点
                if (this.user.coordinate) {
                    //this.user.coordinate = '39.998596,116.340363';

                    let userLat = this.user.coordinate.split(',')[0];
                    let userLng = this.user.coordinate.split(',')[1];
                    let userPoint = new this.BMap.Point(userLng, userLat);
                    let userMarker = new this.BMap.Marker(userPoint, {
                        icon: new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
                            scale: 1.2,
                            fillColor: "#FDB530",
                            fillOpacity: 0.8
                        })
                    });

                    this.map.addOverlay(userMarker);
                    let label = new this.BMap.Label(this.$t('train.signPoint'), {offset: new this.BMap.Size(20, -10)});
                    userMarker.setLabel(label);
                }
            },
        },
        watch: {},
        components: {
            StuPage,
        }
    }
</script>

<style scoped lang="scss">
    @import "../../style/const";

    .offline-container {
        width: 80%;
        margin: 0 auto;
    }

    .task-title {
        width: 96%;
        margin: -20px auto 25px auto;
        font-size: 16px;
        text-align: center;
        font-weight: 600;
    }

    .task-info {
        display: flex;
        p {
            line-height: 1.6;
            margin-left: 8px;
        }

        .basic-info, .user-info {
            flex: 1;

            h3 {
                display: inline-block;
                padding: 4px 8px;
                margin-bottom: 10px;
                font-size: 15px;
                border-left: 3px solid #4c4c4c;
            }
        }

        .user-info {
        }
    }

    .bm-map {
        //width: 80%;
        margin: 20px auto 0 auto;

        .bm-view {
            height: 500px;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
        }

        /deep/ img {
            max-width: none;
        }
    }
</style>
